import { create } from 'zustand'

interface HeaderConfig {
  title: string
  showBackButton: boolean
}

interface HeaderState {
  custom: HeaderConfig | null
  setHeader: (config: HeaderConfig) => void
  clearHeader: () => void
}

export const useHeaderStore = create<HeaderState>()((set) => ({
  custom: null,
  setHeader: (config) => set({ custom: config }),
  clearHeader: () => set({ custom: null }),
}))